/**
 * @fileoverview ESM mirror of ../resolveLaunchPolicy.js.
 * @module @puffin-core/cross-app-policy/resolveLaunchPolicy
 */

import { APP_REGISTRY, SOURCE_MODES, TARGET_MODES } from './registry.js';
import { permissionKeyFor } from './permissionKeyFor.js';

function resolveLaunchPolicy(sourceAppKey, targetAppKey) {
  const source =
    typeof sourceAppKey === 'string' &&
    Object.prototype.hasOwnProperty.call(APP_REGISTRY, sourceAppKey)
      ? APP_REGISTRY[sourceAppKey]
      : null;
  const target =
    typeof targetAppKey === 'string' &&
    Object.prototype.hasOwnProperty.call(APP_REGISTRY, targetAppKey)
      ? APP_REGISTRY[targetAppKey]
      : null;

  if (sourceAppKey === targetAppKey && source !== null) {
    return { mode: 'self' };
  }

  if (!source || !target) {
    return { mode: 'unknown' };
  }

  if (source.sourceMode === SOURCE_MODES.SHARED_TERMINAL) {
    return { mode: 'login-redirect', target };
  }

  if (
    source.sourceMode === SOURCE_MODES.TRUSTED &&
    target.targetMode === TARGET_MODES.SSO_RECEIVABLE
  ) {
    return {
      mode: 'sso-mint',
      target,
      requiredPermission: permissionKeyFor(target.appKey),
    };
  }

  return { mode: 'unknown' };
}

export { resolveLaunchPolicy };
